import { z } from 'zod';
import { acquisitionSourceSchema } from '../../tracking/acquisitionSource.js';
import { partnerCockpitLanguageSchema } from '../user-management/auth.js';
export const requestOnboardingLinkSchema = z.object({
    email: z.email(),
    tosAccepted: z.literal(true),
    acquisitionSource: acquisitionSourceSchema.optional(),
    language: partnerCockpitLanguageSchema.optional(),
});
